import { Injectable } from '@angular/core';

import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/firestore";
import { FirebaseApp } from "@angular/fire";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public user$: Observable <any> = this._authfb.user;

  detailUser;

  private dbPath = '/users';
  objetoRef: AngularFirestoreCollection<any> = null;

  constructor(
    public _authfb:AngularFireAuth,
    private db:AngularFirestore,
    private app: FirebaseApp
  ) {
    this.objetoRef = db.collection(this.dbPath);
  }

  public isAuthenticated() {

    let estatus = false;

    this._authfb.onAuthStateChanged( async user => {
      if(user){
        estatus = await true;
      }else{
        estatus = await false;
      }
    })

    console.log({estatus})
    return estatus;

  }

    // Inicio de Sesion
    async login(email: string, password:string){
      try {
        return await this._authfb.signInWithEmailAndPassword(email, password);
      } catch (error) {
        console.error("Login Error->", error);
        return error;
      }
    }

      // Cambiar password
  async resetPassword(email: string){
    try {
      return await this._authfb.sendPasswordResetEmail(email);
    } catch (error) {
      console.log("Reset Password Error->", error);
      return error;
    }
  }

    // Registrar nuevo usuario
    async register(email:string, password: string, name?:string){
      try {
        const result = await this._authfb.createUserWithEmailAndPassword(email, password);
  
        this._authfb.user.subscribe(user => {
          this.saveUserInfo(email, user.uid, name, 'user');  
        });
  
        return result;
      } catch (error) {
        console.log("Register Error->", error);
        return error;
      }
    }
  
    async saveUserInfo(email:string, uid:string, name:string, rol:string = 'user', status:boolean = true){
  
      const data = {
        uid:uid,
        email: email,
        name: name,
        rol: rol,
        status: status,
        fecha_mod: new Date()
      }
  
      try {
          // Guardar datos del usuario
          this.db.collection('users').doc(email).set(data);
  
      } catch (error) {
        console.error("No se pudieron guardar los datos del usuario");
      }
    }

      // Cerrar Sesion
  async logout(){
    try {
      await this._authfb.signOut();
    } catch (error) {
      console.log("Logout Error->", error);
      return error;
    }
  }

  getUsuarios(email:string){
    try {
      return this.db.collection('users').doc(email).snapshotChanges();
    } catch (error) {
      console.log("GetUsuarios Error")
      return null;
    }
  }

  getUser(email:string){
    try {
      return this.db.collection('users').doc(email);
    } catch (error) {
      console.log("GetUsuarios Error")
      return null;
    }
  }

  getAllUsers():AngularFirestoreCollection<any>{
    try {
      return this.db.collection('users');
    } catch (error) {
      console.log("GetUsuarios Error")
      return null;
    }
  }

  editUser(obj){
    return this.objetoRef.doc(obj.email).update(obj);
  }
}
